import { render } from "./BasicRow.vue?vue&type=template&id=21d53551&scoped=true"
import script from "./BasicRow.vue?vue&type=script&lang=js"
export * from "./BasicRow.vue?vue&type=script&lang=js"

import "./BasicRow.vue?vue&type=style&index=0&id=21d53551&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d53551"]])

export default __exports__